/**
 * Tarih yardımcıları (shared util).
 *
 * Sprint 2.9 T1-B: JobsPage urlFilter='today_completed' → backend
 * `completed_after` query param için kullanıcının tarayıcı yerel gün
 * başlangıcını (00:00 lokal) UTC ISO formatında döner.
 *
 * Backend `completed_at >= $N::timestamptz` ile karşılaştırır → multi-tenant
 * TZ-safe (T7-B `today_start` pattern'i).
 *
 * Aynı helper DashboardPage'de de mevcut (local copy, line 39-43).
 * Backlog: DASHBOARD-TODAYSTART-UTIL (Sprint 2.9-A T1-B scope dışı —
 * DashboardPage refactor ayrı görev; drift riski minimal: 3-satır fn).
 */

/**
 * Kullanıcı tarayıcı yerel günü için bugünün başlangıcını ISO döner.
 * Örnek: TRT 00:00 → "2026-05-24T21:00:00.000Z" (UTC normalize)
 */
export function todayStartIso() {
  const d = new Date();
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}
